import { Button, Card, Col, Image, Row } from "antd";
import DashboardTemplate from "../../templates/Dashboard";
import Header from "../../atoms/Header";
import { NeedHelp } from "../../atoms/CustomIcons";
import companySettingsData from "./Components/Data/companySettingsData.json";
import { useLocation, useNavigate } from "react-router-dom";

export default function CompanySettings() {
  const navigate = useNavigate();
  const url = useLocation();
  const id = url?.pathname.split("/")[2];
  return (
    <DashboardTemplate loading={false}>
      <Header
        title="Company settings"
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
        btnText2="Export system logs"
      />
      <div className="maxWidth">
        <Row gutter={20}>
          <Col md={24} lg={24} xl={24} xs={24}>
            {companySettingsData.map((data, index) => (
              <div key={index} className="company_cards">
                <h3> {data?.title} </h3>
                <div className={`cards ${data?.title?.toLowerCase()}`}>
                  {data?.cards.map((card, idx) => (
                    <Button
                      type="text"
                      key={idx}
                      onClick={() =>
                        card?.link && navigate(`${card.link}/${id}`)
                      }
                    >
                      <Card>
                        <Image
                          src={card.icon}
                          alt={card.title}
                          preview={false}
                        />
                        <h6> {card.title} </h6>
                        <p> {card.description} </p>
                      </Card>
                    </Button>
                  ))}
                </div>
              </div>
            ))}
          </Col>
        </Row>
      </div>
    </DashboardTemplate>
  );
}
